<template>
<div>
  <div class="search-wrap">
    <el-button size="mini" @click="pageChange(1)">查询</el-button>
<!--    <el-button size="mini" @click="computeDosageNumber()">生成</el-button>-->
<!--    <el-button size="mini" @click="getExcel()">导出</el-button>-->
    <!--    <el-button size="mini" @click="ocr()">识别</el-button>-->
  </div>
  <div>
    <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'41%'}">
      <el-descriptions-item label="项目房产">
        {{mainObj.house_name?mainObj.house_name:'请选择项目房产'}}
      </el-descriptions-item>
      <el-descriptions-item label="仪表编号">
        <el-input size="mini" placeholder="请输入仪表编号" v-model="where.number" @change="pageChange(1)" clearable></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="仪表名称">
        <el-input size="mini" placeholder="请输入仪表名称" v-model="where.name" clearable @change="pageChange(1)"></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="仪表类型">
        <el-select size="mini" style="width: 100%" v-model="where.meter_type" clearable filterable placeholder="类型" class="kuan" @change="pageChange(1)">
          <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-descriptions-item>
    </el-descriptions>
  </div>
  <div>
    <el-table v-if="pageData" v-loading="loading" border :data="pageData.list" width="99%" height="60vh" >
      <!--      <el-table-column type="selection" width="55"></el-table-column>-->
      <!--        <el-table-column prop="id" label="id" width="80"></el-table-column>-->
<!--      <el-table-column prop="chargeItem_name" label="费项类型"  width="150"></el-table-column>-->
      <el-table-column prop="name" label="费项名称"  width="250"></el-table-column>
      <el-table-column prop="price" label="成本单价"  width="200">
        <template slot-scope="scope">
          <input type="number" class="number-input" v-model="scope.row.cost_price" @change="setMeterOrderPrice(scope.row)" />
        </template>
      </el-table-column>
      <el-table-column prop="price" label="销售单价"  width="200">
        <template slot-scope="scope">
          <input type="number" class="number-input" v-model="scope.row.price" @change="setMeterOrderPrice(scope.row)" />
        </template>
      </el-table-column>
      <el-table-column prop="update_time" label="操作时间"  width="200"></el-table-column>
      <el-table-column prop="user_name" label="操作人" width="150"></el-table-column>
      <el-table-column prop="user_name" label="操作" >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="initMeterOrderPrice(scope.row)">初始单价</el-button>
        </template>
      </el-table-column>

    </el-table>
  </div>
  <div style="margin-top: 20px;text-align: center;margin-right: 20px;">
    <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
  </div>
</div>
</template>

<script>
import MeterHttp from "../../../common/MeterHttp";

export default {
  name: "MeterOrderPrice",
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return{
      where:{
        number:"",
        name:"",
        apportion_meter_types:[1,2],
        meter_type:""
      },
      apportion_meter_type_list:[{name:"存用量",val:1},{name:"线损",val:2}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
      energy_obj:{1:"业主能耗",2:"物业能耗",3:"分摊能耗"},
      meter_type_list: [],
      loading: false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
    }
  },
  mounted() {
    this.getMeterTypeList();
    this.pageChange(1)
  },
  methods:{
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_ids,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      });
    },
    pageChange(i){
      this.pageData.page = i
      this.getList()
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      where.read_month=that.mainObj.read_month;
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      MeterHttp.post("MeterOrderPrice/getOrderList",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      },res=>{
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
        that.multipleSelection = []
      });
    },
    setMeterOrderPrice(item){
      const that = this;
      that.$confirm(`您是否确定修改【${item.name}】的计费单价?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = ERP.reJson(item);
        MeterHttp.post("MeterOrderPrice/setMeterOrderPrice",data,res=>{
          if (res.code) {
            that.$message({
              type: 'success',
              message: '设置成功!'
            });
            that.getList()
          }else {
            this.$message({
              type: 'info',
              message: res.msg||"修改异常"
            });
          }
        });

      });
    },
    initMeterOrderPrice(item){
      const that = this;
      that.$confirm(`该费项初始化单价：${item.charge_price}元，您是否确定初始化【${item.name}】的计费单价?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = ERP.reJson(item);
        data.price=data.charge_price;
        MeterHttp.post("MeterOrderPrice/setMeterOrderPrice",data,res=>{
          if (res.code) {
            that.$message({
              type: 'success',
              message: '设置成功!'
            });
            that.getList()
          }else {
            this.$message({
              type: 'info',
              message: res.msg||"修改异常"
            });
          }
        });

      });
    }
  },
  watch:{
    "mainObj.house_name":function (n,o) {
      if(n){
        this.pageChange(1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common";
.number-input{
  background-color: #ffe5d5;
  color: black;
  width: 100%;
  &[disabled]{
    background-color: #ececec;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/components/MeterOrderPrice.vue